// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1UsersCreateSchema = z.object({
  user: z.object({
    admin: z.optional(z.boolean().describe("**(Deprecated)**  \n                      Requires admin role")),
    hide_hourly_rate: z.optional(z.boolean()),
    hide_internal_hourly_rate: z.optional(z.boolean().describe("The hide_internal_hourly_rate hides the internal hourly rate for users in the account. The default is **true**")),
    default_hour_rate: z.optional(z.number().int().min(0)),
    external_id: z.optional(z.coerce.string().max(512).describe("Can be used to reference external resource IDs to Timely resources")),
    weekly_capacity: z.optional(z.number().int().gt(0).describe("Specifies the user's weekly hour capacity. The default is account's weekly capacity. Can only have a decimal place of .5 (e.g. 3.5 hours)")),
    team_ids: z.optional(z.number().int()),
    internal_hour_rate: z.optional(z.number().int().min(0).describe("Specifies the internal hourly rate for user")),
    add_to_all_projects: z.optional(z.boolean().describe("Specifies whether the user should be added to all projects in the account")),
    apply_default_rate: z.optional(z.boolean()),
    capacity: z.optional(z.object({
      id: z.number().int().nullish(),
      weekly_capacity: z.number().min(0),
      daily_capacity: z.number().min(0),
      weekdays: z.coerce.string().nullish(),
      work_days: z.coerce.string(),
      total_working_days: z.number().int().min(0).nullish(),
      weekly_working_days: z.number().int().min(0).max(7),
      current: z.boolean(),
      start_date: z.string().date(),
      end_date: z.string().date().nullish(),
    })),
    properties_attributes: z.optional(z.array(z.union([z.object({
      id: z.number().int(),
      value: z.coerce.string().min(1).max(50),
    }), z.object({
      id: z.number().int(),
      _destroy: z.boolean(),
    }), z.object({
      account_user_property_id: z.number().int(),
      value: z.coerce.string().min(1).max(50),
    })])).describe("Array item can describe **update** | **delete** | **create** actions")),
    projects: z.optional(z.union([z.object({
      create: z.optional(z.array(z.object({
        project_id: z.number().int(),
        hour_rate: z.optional(z.number()),
      }))),
    }), z.array(z.object({
      project_id: z.number().int(),
      hour_rate: z.optional(z.number()),
    }))])),
    user_level: z.optional(z.enum(["normal", "limited"]).describe("**(Deprecated)**  \n                         Specifies the user level  \n                         Required if **role_id** is blank.  \n                         Must be **normal** if **role_id** is blank and **admin** is true  \n                         Must be **limited** if **role_id** is blank and **hide_hourly_rate** is true  \n                         Must be **limited** if **role_id** is blank and **hide_internal_hourly_rate** is true\"")),
    role_id: z.optional(z.number().int().describe("Specifies the user's role in the account. Required if **user_level** is blank")),
    name: z.coerce.string().min(1),
    email: z.coerce.string().min(1).regex(new RegExp("^([^@\\s]+)@((?:[-a-z0-9]+\\.)+[a-z]{2,})$")),
  }),
});
